import {
  fetchClient
} from "./chunk-K342ITN7.mjs";
import {
  __async,
  __spreadValues
} from "./chunk-DFMI36TU.mjs";

// src/core/wbk/survey/list.ts
import { Exception } from "@wbk/logger";
var getSurvey = (_0) => __async(void 0, [_0], function* ({ lang, limit = 15, organizationID, slug }) {
  const params = new URLSearchParams(__spreadValues(__spreadValues({
    lang,
    limit: limit.toString()
  }, organizationID && { organization: organizationID }), slug && { event_slug: slug }));
  const url = `/survey/questions?${params.toString()}`;
  try {
    const data = yield fetchClient({ url });
    return data.data;
  } catch (error) {
    throw new Exception({
      error,
      name: "getSurveyException",
      context: { tags: { journey: "survey" } }
    });
  }
});

export {
  getSurvey
};
//# sourceMappingURL=chunk-RATRWSNO.mjs.map